import React from "react";
import Navbar from "../Components/Navbar";
import mainkv from "../Assets/mainkv.png";
import timelinebrief from "../Assets/timelinebrief.png";
import prize from "../Assets/prize.png";
import footer from "../Assets/footer.png";
import { List } from "@mui/material";

const Home = () => {
  return (
    <div className="App">
      <Navbar />
      <img src={mainkv} alt="" />

      <div className="briefbanner-container">
        <h1 className="briefbanner-header">Win up to $10,000 in cash!</h1>
        <br />

        <h4 className="briefbanner-subheaderpink">
          This is your chance to create real impact in Singapore’s healthcare
          future by designing AI driven solutions that support better health
          outcomes and quality of life.
        </h4>
        <br />

        <p className="briefbanner-content">
          Chronic diseases continue to rise in Singapore. Continuous and
          personalised care is more important than ever. Can your solution use
          Agentic AI and Generative AI to empower patients, strengthen
          engagement, and help bridge the gap between clinicians and individuals
          in everyday life?
          <br />
          <br />
          Or step into the frontier of vision based and multimodal health
          monitoring. Use computer vision, voice and sensor data to detect
          stress, track wellness and identify health changes in real time,
          outside traditional clinical settings.
          <br />
          <br />
          Think boldly. Innovate responsibly. Shape the future of proactive and
          personalised healthcare for Singapore.
          <br />
          <br />
          Open to students from universities, polytechnics and junior colleges
          in Singapore.
        </p>
        <br />
        <br />

        <a
          href="https://forms.gle/3giRmAv7SB1jKpXg6"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="register-btn">Submit Second Submission</button>
        </a>
      </div>

      <div className="bodycopy-container">
        <h2 className="primary-header">Problem Statement</h2>
        <br />
        <br />
        <h4 className="subheader">
          Problem Statement 1: Agentic AI for Patient Empowerment
        </h4>
        <br />
        <p>
          Singapore is facing a growing public health challenge with the rising
          prevalence of chronic diseases. One in four Singaporeans aged 40 and
          above lives with at least one chronic condition, placing a significant
          strain on our healthcare resources. A major hurdle in managing these
          conditions is the difficulty in providing continuous, personalised
          support to patients outside the clinical setting, leading to issues
          with medication adherence, lifestyle management, and overall patient
          engagement.
          <br />
          <br />
          For this innovation challenge, the user persona could be someone like
          Mr. Tan, a patient in his 60s with multiple chronic conditions who
          struggles to keep track of follow-up medical appointments and
          frequently misses his medication schedule. Beyond patients like Mr.
          Tan, the target users may also include pre-conditioned
          individuals—such as those living with chronic illnesses, mobility
          limitations, or cognitive challenges—as well as their caregivers, who
          support them in managing daily care needs. The proposed AI solution is
          designed to assist any of these groups by fostering a more organized,
          supported, and actively engaged healthy community.
        </p>
        <br />

        <p className="textbold">
          We are seeking innovative ideas to answer these key questions:
        </p>
        <br />
        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            Proactive Patient Engagement: How can an Al agent move beyond
            passive reminders to proactively and empathetically engage patients
            in managing their chronic conditions (e.g., Type 2 Diabetes),
            anticipating their needs and motivating them towards better health
            outcomes?
          </li>
          <br />
          <li className="bodycopy-format">
            Hyper-Personalization of Care: How can Generative Al synthesise
            diverse data sources-such as electronic health records, wearable
            device data, and patient-reported outcomes to provide truly
            personalised, context-aware, and culturally relevant health advice,
            dietary recommendations, and educational content?
          </li>
          <br />
          <li className="bodycopy-format">
            Bridging the Gap between Patient and Clinician: How can the insights
            gathered by the Al companion be intelligently summarised and
            presented to healthcare professionals, enabling them to make more
            timely and informed interventions without increasing their
            administrative burden?
          </li>
          <br />
          <li className="bodycopy-format">
            Measuring Real-World Impact: What frameworks and metrics can be
            developed to measure the success of the Al Health Companion in terms
            of quantifiable benefits (e.g., improved medication adherence,
            better biometric readings) and strategic advantages (e.g., reduced
            hospital readmissions, enhanced healthcare efficiency)?{" "}
          </li>
        </ul>

        <br />
        <br />

        <h4 className="subheader">
          Problem Statement 2: AI for Multimodal Remote Health and Wellness
          Monitoring
        </h4>
        <br />
        <p>
          Advances in computer vision and sensing technologies have opened new
          possibilities for non-contact, remote assessment of human health and
          well-being. Everyday devices such as smartphones, webcams, and
          wearable cameras can capture rich visual cues related to a person’s
          physical, emotional, and physiological state. When combined with other
          accessible data sources — such as voice, motion, or environmental
          signals — these visual insights can provide powerful indicators of
          wellness and early signs of health changes. <br />
          <br />
          Participants are invited to develop an AI solution that uses visual
          data, alone or in combination with other modalities, to monitor or
          assess aspects of health and wellness in real-world settings.{" "}
        </p>
        <br />

        <p className="textbold">
          Possible directions include, but are not limited to:
        </p>
        <br />
        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            Estimating physiological signals (e.g., heart rate, respiration,
            fatigue) from facial or upper-body videos
          </li>
          <br />
          <li className="bodycopy-format">
            Detecting stress, emotion, or cognitive load through visual
            behaviours and expressions
          </li>
          <br />
          <li className="bodycopy-format">
            Assessing movement quality, posture, or physical activity using
            video or pose estimation
          </li>
          <br />
          <li className="bodycopy-format">
            Integrating visual features with audio, motion, or contextual data
            for comprehensive wellness evaluation
          </li>
        </ul>
        <br />

        <p className="textbold">
          Solutions should prioritize innovation, practicality, and robustness,
          demonstrating how AI can make health monitoring more accessible,
          continuous and meaningful for real-world use.
          <br />
          <br />
          This challenge is more than a competition; it is an opportunity to
          design a solution that could positively impact the health of
          Singaporeans. Design a prototype that showcases how an agentic Al
          system can interact with patients, interpret their data, and provide
          intelligent, supportive advisories.
        </p>
        <br />

        <h4 className="subheader">
          Join us to shape the future of proactive and personalised healthcare
          in Singapore.
        </h4>
        <br />
        <br />

        <h2 className="primary-header">Timeline</h2>
        <br />

        <img src={timelinebrief} className="timelinebrief" alt="" />
        <br />
        <br />
        <br />
        <h2 className="primary-header">Prize</h2>

        <br />
        <img src={prize} alt="" />
        <br />
        <br />
        <br />
        <img src={footer} alt="" />
        <br />
        <br />
      </div>
    </div>
  );
};

export default Home;
